import { styled } from '@mui/material/styles'
import { TextField } from '@mui/material'

export const Input = styled(TextField)({
  '& .MuiFormControl-root': {
    width: '350px',
    height: 35,
  },
  '& .MuiInputBase-root': {
    height: '40px',
    borderRadius: 32,
    background: '#F9F9F9',
    textAlign: 'center',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: 'normal',
    textTransform: 'none',
    '& fieldset': {
      border: '1px solid #E8E7EC',
      fontFamily: 'Montserrat',
    },
    '& input': {
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px #fff inset',
        WebkitTextFillColor: 'default',
      },
      '& input:-internal-autofill-selected': {
        backgroundColor: 'transparent !important',
      },
    },
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#ADB84E',
    },
  },
  '&:hover': {
    background: '#F9F9F9',
    transform: 'scale(1.02)',
    transition: 'all 0.2s ease-in-out',
  },
})
